import { render } from "./ShowUserDetails.vue?vue&type=template&id=cd7f5f12"
import script from "./ShowUserDetails.vue?vue&type=script&lang=js"
export * from "./ShowUserDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__